import {
    RN_AI_AUDIO_PUBLIC_BASE_URL,
    RN_AI_AUDIO_S3_BUCKET,
} from "./rn-ai-agent-constants";
import { normalizeRnAiAudioPath, rnAiAudioS3KeyCandidates } from "./rnAiAudioKeys";

export type RnAiAudioUrlResult = {
    url: string | null;
    error?: string;
};

type PresignFn = (bucket: string, path: string) => Promise<string | null>;

export function rnAiAudioPublicUrl(audioPath: string): string | null {
    const key = normalizeRnAiAudioPath(audioPath);
    if (!key) return null;
    return `${RN_AI_AUDIO_PUBLIC_BASE_URL}/${key}`;
}

export async function resolveRnAiAudioUrl(
    presign: PresignFn,
    audioPath: string
): Promise<RnAiAudioUrlResult> {
    const candidates = rnAiAudioS3KeyCandidates(audioPath);
    if (!candidates.length) {
        return { url: null, error: "Missing audio path." };
    }

    for (const key of candidates) {
        const url = await presign(RN_AI_AUDIO_S3_BUCKET, key);
        if (url) return { url };
    }

    const publicUrl = rnAiAudioPublicUrl(audioPath);
    if (publicUrl) return { url: publicUrl };

    return {
        url: null,
        error: "Could not load audio. Check that the file exists in storage or on the public site.",
    };
}
